import { render } from "./TokenCredentialFields.vue?vue&type=template&id=6fb7b01c"
import script from "./TokenCredentialFields.vue?vue&type=script&lang=js"
export * from "./TokenCredentialFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__